import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { LoginService } from '../../login/login.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import {Element, AutomatedTest, AutomatedTestStep, AutomatedTestArea, AutomatedTestParameter, AutomatedTestStatus } from '../models/ast-element.model';
import { AutomatedTestingModalComponent } from './automated-testing-modal.component';
import { ConfirmModalComponent } from './confirm.component';
import {TylerMatTableDataSource} from '../../../shared-components/angular-material/extended.class';
import { ReportLegendComponent } from '../report-legend/report-legend.component';
import { QuickViewModalComponent } from './quickview.component';
import { ElementListModalComponent } from './element-list.component';
import { AreaListModalComponent } from './area-list.component';

@AutoUnsubscribe()
@Component({
    selector: 'automatedTestingSetup',
    templateUrl: './automated-testing-setup.component.html',
    styleUrls: ['./automated-testing-setup.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})



export class AutomatedTestingSetupComponent implements OnInit, OnDestroy {



    thisDialogRef: MatDialogRef<AutomatedTestingSetupComponent>;

    modalDialogRef: MatDialogRef<AutomatedTestingModalComponent>;
    confirmDialogRef: MatDialogRef<ConfirmModalComponent>;
    reportLegendDialogRef: MatDialogRef<ReportLegendComponent>;
    elementListDialogRef: MatDialogRef<ElementListModalComponent>;
    areaListDialogRef: MatDialogRef<AreaListModalComponent>;
    quickViewDialogRef: MatDialogRef<QuickViewModalComponent>;

    @ViewChild(MatSort) sort: MatSort;

    testAreas: string[];
    testArea = '';

    testSubAreas: string[];
    testSubArea = '';

    elementAreas: string[];
    elementArea = '';

    elementSubAreas: string[];
    elementSubArea = '';

    tests: AutomatedTest[] = [];
    test = new AutomatedTest();


    testSteps: AutomatedTestStep[] = [];

    allElements: Element[] = [];
    elements: Element[] = [];
    // element: Element;

    allAreas: AutomatedTestArea[] = [];
    distinctAreas: AutomatedTestArea[] = [];
    selectedArea: AutomatedTestArea = new AutomatedTestArea();

    // elementActions: ElementAction[];

    identifiers: string[] = [];

    actions: string[] = [];

    actionName: string;

    action = '';
    controlName = '';
    identifier = '';
    dataInput = '';
    testText = '';
    testData = '';

    dataSource: TylerMatTableDataSource;
    columnsToDisplay: string[] = [];
    showFilter = false;
    checkAllIsSubTestOnly = false;

    // elementListItems: DataSource[] = [];
    // allElementsListItems: DataSource[] = [];

    showTests = true;
    showTestSteps = false;

    insertStepType = '';
    insertStepNumber = 0;

    parameters: AutomatedTestParameter[] = [];
    parameter: AutomatedTestParameter;
    showParameters = false;

    testSaved = false;

    inDebugMode = false;

    isFiltered = false;

    V10: boolean;
    // step: AutomatedTestStep;

    constructor(
        automatedTestingSetupDialogRef: MatDialogRef<AutomatedTestingSetupComponent>,
        automatedTestingModalDialogRef: MatDialogRef<AutomatedTestingModalComponent>,
        private modalDialog: MatDialog,
        private reportLegendDialog: MatDialog,

        _elementListDialogRef: MatDialogRef<ElementListModalComponent>,
        private _elementListDialog: MatDialog,

        _areaListDialogRef: MatDialogRef<AreaListModalComponent>,
        private _areaListDialog: MatDialog,

        _confirmDialogRef: MatDialogRef<ConfirmModalComponent>,
        private _confirmDialog: MatDialog,

        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent
        private loginService: LoginService,
        private dialog: MatDialog,
        private quickViewDialog: MatDialog,
    ) {

        this.thisDialogRef = automatedTestingSetupDialogRef;
        this.modalDialogRef = automatedTestingModalDialogRef;
        this.confirmDialogRef = _confirmDialogRef;
        this.elementListDialogRef = _elementListDialogRef;
    }

    ngOnInit() {
        this.inDebugMode = false;
        this.V10 = this.loginService.LoginSettings.V10;

        if (this.reportService.inDebugMode) {
          this.inDebugMode = true;

        }

        // this.columnsToDisplay = ['TestAreaName', 'TestSubAreaName', 'TestName', 'IsSubTestOnly', 'Approved', 'TestStatus', 'Actions'];
        this.columnsToDisplay = ['TestAreaName', 'TestSubAreaName', 'TestName', 'IsSubTestOnly', 'TestStatus', 'Actions'];

        // let tests: any;
        this.getAutomatedTests(0); // 0 to get only the tests, not the steps

        // this.getAutomatedTestParameters(0, 0);


    }

    ngOnDestroy() { }

    // openConfirmPopup(title: string, message: string): boolean {

    //   this.confirmDialogRef = this._confirmDialog.open(
    //     ConfirmModalComponent,
    //   {
    //     data: {
    //         PageTitle: title,
    //         Message: message
    //       },
    //     panelClass: 'tyl-mat-dialog',
    //     disableClose: true,

    //   });

    //   this.confirmDialogRef.afterClosed().subscribe(result => {

    //     return result;


    //   });

    // }

    checkIsSubTestOnly(element: AutomatedTest, checked: boolean) {

      // // console.log(element);
      // // console.log(checked);

    }

    allIsSubTestOnlyChecked() {
      this.checkAllIsSubTestOnly = !this.checkAllIsSubTestOnly;
    }

    allEventChecked() {
      // this.selectedEvents = [];
      for (const item of this.dataSource.data) {
          item.IsSubTestOnly = this.checkAllIsSubTestOnly;


      }
  }

  editTestClick(theTest: AutomatedTest) {
    this.test = theTest;
    this.openModalPopup('editTest');
  }

  viewTestStepsClick(thisTest: AutomatedTest) {
    this.testSaved = true;
    // console.log(thisTest);
    this.test = thisTest;
    this.showTests = false;
    this.showTestSteps = true;
    this.getAutomatedTestSteps(thisTest.Test_ID);
    this.getAutomatedTestParameters(thisTest.Test_ID, 0);
  }

  viewDependentTests(thisTest: AutomatedTest) {
    console.log(thisTest);

    this.quickViewDialogRef = this.quickViewDialog.open(QuickViewModalComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      data: {
        PageTitle: thisTest.TestAreaName + ' - ' + thisTest.TestSubAreaName  + ' - ' + thisTest.TestName,
        Test: thisTest,
        Message: 'The following tests are dependent on this shared test',
        viewDependentTests: true,
        showTestSteps: false,
      },

    });
  }

  showQuickView(thisTest: AutomatedTest) {

    // console.log(thisTest);

    this.quickViewDialogRef = this.quickViewDialog.open(QuickViewModalComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      data: {
        PageTitle: thisTest.TestAreaName + ' - ' + thisTest.TestSubAreaName  + ' - ' + thisTest.TestName,
        Test: thisTest,
        Message: thisTest.Comments,
        viewDependentTests: false,
        showTestSteps: true,
      },

    });
  }

  copyTestClick (thisTest: AutomatedTest) {
    this.test = this.test = thisTest;
    this.openModalPopup('copyTest');

    // console.log(thisTest);
    // this.test = thisTest;
    // this.showTests = false;
    // this.showTestSteps = true;
    // this.getAutomatedTestSteps(thisTest.Test_ID);
    // this.getAutomatedTestParameters(thisTest.Test_ID, 0);
  }


    toggleExpanded(row: any) {
      this.dataSource.toggleExpanded(row);
  }

  checkExpanded(row: any): boolean {
      return this.dataSource.checkExpanded(row);
  }

  expandAll(expand: boolean) {
      this.dataSource.expandAll(expand);
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
      this.dataSource.rowKeyPress(event, row);
  }

  showFilterClick() {
      this.showFilter = !this.showFilter;
  }

  clearFilter() {
      // this.clearFilterEvent.emit();
      this.dataSource.removeAllFilters();
      // this.communicationLogFilter.clearFilter();
  }

    trackByFn(item: AutomatedTest, index: number) {
      // POST: returns a value to track an item by so we can avoid change detection
      return item.Test_ID;
  }

    openModalPopup(actionToTake: string) {

      // console.log(this.test);
      // console.log(this.parameter);


        // console.log(actionToTake);
        const testOrder = this.tests.length + 1;

        let pageTitle: string;
        let copyTestId: number;

        if (actionToTake == 'copyTest') {
          pageTitle = 'Add New Test - Copy Steps from: ' + this.test.TestName;
          copyTestId = this.test.Test_ID;
          this.test = new AutomatedTest();
          this.parameter = null; // ??
         // parentTest_ID: this.test.Test_ID,
        }


        if (actionToTake == 'addTest') {
            pageTitle = 'Add New Test';
            this.test = new AutomatedTest();
            this.test.Test_ID = null;
        }

        if (actionToTake == 'addSubTest') {
            pageTitle = 'Add Shared Test';
        }

        if (actionToTake == 'editTest') {
          pageTitle = 'Edit Test';
        }

        if (actionToTake == 'insertStep') {
          pageTitle = 'Insert Step';
        }

        if (actionToTake == 'addParameter') {
          pageTitle = 'Add Parameter';
        }

        if (actionToTake == 'editParameter') {
          pageTitle = 'Edit Parameter';
        }

        // if (actionToTake == 'addStepComment') {
        //   pageTitle = 'Add Step #' + this.step.StepOrder + ' Comment';
        // }

        // if (actionToTake == 'editStepComment') {
        //   pageTitle = 'Edit Step #' + this.step.StepOrder + ' Comment';
        // }


        // console.log(this.parameter);

        this.modalDialogRef = this.modalDialog.open(
            AutomatedTestingModalComponent,
          {
            data: {
                action: actionToTake,
                title: pageTitle,
                testAreas: this.testAreas,
                testSubAreas: this.testSubAreas,
                testOrder: testOrder,
                tests: this.tests,
                allAreas: this.allAreas,
                test: this.test,
                parameter: this.parameter,
                parentTest_ID: this.test.Test_ID,
                copyTestId: copyTestId,
                // step: this.step,;
              },
            panelClass: 'tyl-mat-dialog',
            disableClose: true,

          });

          this.modalDialogRef.afterClosed().subscribe(result => {

            if (this.inDebugMode) {
              console.log('HERE');
              console.log(result);
            }

            // return;

            if (result == undefined || result == null) {
              return;
            }


            if (result == undefined || result == null || actionToTake == 'editParameter' || actionToTake == 'addParameter') {

              // console.log(result);

              this.reportService.getAutomatedTestParameters(this.test.Test_ID, 0).subscribe(res => {
                this.parameters = res;
                if (this.inDebugMode) {
                  console.log(this.parameters);
                }
                // console.log(this.parameters);
                this.showParameterGrid(false);

                if (this.inDebugMode) {
                  console.log('HERE');
                }
                return;
              });
            }


            if (result == undefined || result == null || actionToTake == 'editParameter' || actionToTake == 'addParameter') {
              return;
            }

            if (this.inDebugMode) {
              console.log('HERE');
            }

            if (actionToTake === 'addTest' && result !== undefined) {
                this.test = result;
                // this.getAutomatedTestSteps(this.test.Test_ID); // This is an alternative fix.
                this.testSteps = [];
                this.showTests = false;
                this.showTestSteps = true;
                return;
            }

            // console.log(this.insertStepType);

            // if (result instanceof AutomatedTestStep) {
            //   this.step.Comments = result.Comments;
            //  // this.insertStepType = 'Regular Step';
            //  console.log(this.testSteps);
            //  return;
            // }

            // console.log(this.step);

            if (result == 'Regular Step') {
              // // console.log(result);
              this.insertStepType = 'Regular Step';
              this.addStep(false);
              return;

            } else if (this.insertStepType) {
              // .log(result);

              let t: AutomatedTest;
              t = result;
              // // console.log(t);

              this.insertStepType = 'Shared Test';
              // this.addStep(true);
              return;
            }

            if (actionToTake === 'editTest') {
                //this.resetPageForShowingTests();
                return;
            }

            // if (actionToTake == 'editParameter' || actionToTake == 'addParameter') {

            //   // console.log(result);

            //   this.reportService.getAutomatedTestParameters(this.test.Test_ID, 0).subscribe(res => {
            //     this.parameters = res;
            //     // console.log(this.parameters);
            //     this.showParameterGrid(false);

            //   });
            // }

            this.insertStepType = '';

            this.reportService.getAutomatedTestAreas(0).subscribe(myAreas => {

              this.allAreas = myAreas;

              // // // // console.log(myAreas);

                // get tests only
                this.reportService.getAutomatedTests(0).subscribe(results => {

                  // // console.log(results);

                    this.tests = results;
                    this.setTestStatus();
                    if (this.tests == null || this.tests == undefined) {
                      this.tests = [];
                    }

                    this.dataSource = new TylerMatTableDataSource(this.tests);
                    this.getTestAreas();
              });


             });

          // console.log('HERE');
          // console.log(result);

            if (result != undefined) {
                // // // // console.log(result);

            let subTest: AutomatedTest;
            subTest = result;

            const newStep = new AutomatedTestStep();
            newStep.Test_ID = 0; // this.test.Test_ID;

            newStep.ElementAreaName = subTest.TestAreaName;
            newStep.ElementSubAreaName = subTest.TestSubAreaName;

            newStep.ElementName = subTest.TestName;
            newStep.InnerTest_ID = subTest.Test_ID;
            newStep.StepOrder = this.testSteps.length + 1;

            // if this is an inserted step, adjust step orders

            if (subTest.IsInsertedStep) {
              newStep.StepOrder = this.insertStepNumber;

              for (let x = this.insertStepNumber - 1; x < this.testSteps.length; x++) {
                this.testSteps[x].StepOrder++;
              }
            }

            const elem = new Element();
            elem.ElementName = subTest.TestName;
            elem.ElementAreaName = subTest.TestAreaName;
            elem.ElementSubAreaName = subTest.TestSubAreaName;

            elem.Actions.push('Execute Steps');
            elem.Action = 'Execute Steps';

            newStep.ActionName = 'Execute Steps';

            newStep.Element = elem;
            newStep.Elements.push(elem);

            this.testSteps.push(newStep);

            }
          });

      }

      getBackgroundColor(step: AutomatedTestStep): string {
        if (step.InnerTest_ID > 0) {
          // indicates it is a shared test
          if (step.Approved)           {
            return 'AliceBlue';
          } else {
            return 'LavenderBlush';
          }

        }

      }

    getAutomatedTests(testId: number) {

      this.reportService.getAutomatedTestAreas(testId).subscribe(myAreas => {

        this.allAreas = myAreas;

        this.distinctAreas = this.allAreas.filter(
          (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
        );

        // // // // console.log(myAreas);

        if (testId == 0 ) {
          // get tests only
          this.reportService.getAutomatedTests(testId).subscribe(results => {

                this.tests = results;

                if (this.inDebugMode) {
                    console.log(this.tests);
                }

                this.setTestStatus();
                this.getTestAreas();

                // get elements for test
                this.reportService.getAutomatedTestElements(testId).subscribe(elem => {

                    this.allElements = elem;

                    // handle filters
                    this.dataSource = new TylerMatTableDataSource(this.tests);

                    this.dataSource.sortingDataAccessor = (item: AutomatedTest, property: string) => {
                        switch (property) {
                            case 'TestStatus':
                                return item.InProgress ? 'In Progress' : (item.Approved ? 'Approved' : (item.ReadyForReview ? 'Ready For Review' : (item.IsObsolete ? 'Is Obsolete' : ' ')));
                            case 'IsSubTestOnly':
                                return item.IsSubTestOnly ? 'Y' : '';
                            default:
                                return this.dataSource.defaultSortingAccessor(item, property);
                        }
                    };

                    // Handle sorting
                    this.dataSource.sort = this.sort;

                    const sortState: Sort = {active: 'TestAreaName', direction: 'asc'};
                    this.sort.active = sortState.active;
                    this.sort.direction = sortState.direction;
                    this.sort.sortChange.emit(sortState);

                // // console.log(this.dataSource);
            });

          });

      }


    });



      }

      showTestsClick() {

        // If the test isn't saved, put up a confirm dialog.
        if (this.testSaved === false) {

            this.confirmDialogRef = this._confirmDialog.open(
                ConfirmModalComponent,
            {
                data: {
                    PageTitle: 'WARNING',
                    Message: 'If you continue without saving, the changes will be lost.'
                },
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
            });

            this.confirmDialogRef.afterClosed().subscribe(result => {

            // user clicked OK
            if (result === 'ContinueWithoutSaving') {
                this.resetPageForShowingTests();
                return;
            }

            if (result === true) {
                this.saveTestStepsClick();
                this.resetPageForShowingTests();
            } else if (result === false) {
                return;
            }

            });
        }

        else if (this.testSaved === true) {
            // testSubAreas: string[];
            // testSubArea = '';
            this.resetPageForShowingTests();
        }
      }

      getAutomatedTestSteps(testId: number) {
            this.testSteps = [];

            this.reportService.getAutomatedTestSteps(testId).subscribe(steps => {
                // console.log(steps);

                // get test steps
               // this.allElements = [];

                // // // // console.log(this.testAreas);
                // // // // console.log(this.allAreas);



                if (steps == undefined || steps == null || steps.length == 0) {

                  return;
                }


                for (let x = 0; x < steps.length; x++) {
                    if (steps[x].Test_ID > 0) {
                        this.testSteps.push(steps[x]);
                    }

                    const elem = new Element();
                    elem.ElementArea_ID = steps[x].ElementArea_ID;
                    elem.ElementAreaName = steps[x].ElementAreaName;
                    elem.ElementSubAreaName = steps[x].ElementSubAreaName;
                    elem.ControlName = steps[x].ControlName;
                    elem.Element_ID = steps[x].Element_ID;
                    elem.ElementName = steps[x].ElementName;
                    elem.XPath = steps[x].XPath;
                    elem.ParameterName = steps[x].ParameterName;
                    elem.ParameterValue = steps[x].ParameterValue;
                    this.allElements.push(elem);
                }

                // // // // console.log(this.allElements);

                // const distinctTests = this.testSteps.filter(
                //     (thing, i, arr) => arr.findIndex(t => t.Test_ID === thing.Test_ID) === i
                // );

                // this.tests = [];
                // let thisTest: AutomatedTest;
                // for (let x = 0; x < distinctTests.length; x++) {


                //     if (distinctTests[x].Test_ID == null || distinctTests[x].Test_ID == undefined) {
                //         continue;
                //     }

                //     // // // // // // console.log(distinctTests[x]);

                //     thisTest = new AutomatedTest();
                //     thisTest.Test_ID = distinctTests[x].Test_ID;
                //     thisTest.TestName = distinctTests[x].TestName;
                //     thisTest.TestArea_ID = distinctTests[x].TestArea_ID;
                //     thisTest.TestAreaName = distinctTests[x].TestAreaName;
                //     thisTest.TestSubAreaName = distinctTests[x].TestSubAreaName;
                //     thisTest.Approved = distinctTests[x].Approved;
                //     thisTest.InProgress = distinctTests[x].InProgress;
                //     thisTest.ReadyForReview = distinctTests[x].ReadyForReview;

                //     this.tests.push(thisTest);
                // }

                // this.getTestAreas();


                this.getElementAreas();

                // console.log(this.testSteps);
            });


      }

      addTest() {

        this.openModalPopup('addTest');
      }

      // This block is reused, so it has been converted into a method.
      resetPageForShowingTests() {
        this.showParameters = false;

        this.elementAreas = [];
        this.elementArea = '';
        this.elementSubAreas = [];
        this.elementSubArea = '';
        this.tests = [];
        this.test = null;
        this.testSteps = [];
        // this.allElements = [];
        this.elements = [];

        this.testSaved = false;

        this.showTests = true;
        this.showTestSteps = false;

        this.getAutomatedTests(0);
      }

      getAllElements() {
            // this.allElements = [];
            // for (let x = 0; x < this.testSteps.length; x++) {
            //     const elem = new Element();
            //     elem.ElementArea_ID = this.testSteps[x].ElementArea_ID;
            //     elem.ElementAreaName = this.testSteps[x].ElementAreaName;
            //     elem.ElementSubAreaName = this.testSteps[x].ElementSubAreaName;
            //     elem.ControlName = this.testSteps[x].ControlName;
            //     elem.Element_ID = this.testSteps[x].Element_ID;
            //     elem.ElementName = this.testSteps[x].ElementName;
            //     elem.XPath = this.testSteps[x].XPath;
            //     elem.ParameterName = this.testSteps[x].ParameterName;
            //     elem.ParameterValue = this.testSteps[x].ParameterValue;
            //     this.testSteps[x].Element = elem;
            //     this.allElements.push(elem);

            //     let listItem: DataSource;
            //     listItem = new DataSource();
            //     listItem.TextField = elem.ElementName;
            //     listItem.ValueField = elem.Element_ID.toString();
            //     listItem.IsSelected = false;

            //     if (elem.Element_ID == this.testSteps[x].Element_ID) {
            //         listItem.IsSelected = true;
            //     }


            //     this.elementListItems.push(listItem);
            //   //  this.allElementsListItems.push
            // }

            // // // // // // // console.log(this.elementListItems);
      }

      getTestAreas() {

        const distinctTestAreas = this.tests.filter(
            (thing, i, arr) => arr.findIndex(t => t.TestArea_ID === thing.TestArea_ID) === i
          );

          // // // // console.log(distinctTestAreas);

          this.testAreas = [];
          for (let x = 0; x < distinctTestAreas.length; x++) {

            if (distinctTestAreas[x].TestArea_ID != null) {
              // right now for tests we only want the Portals in the automation DB


              if (distinctTestAreas[x].TestAreaName == 'Classroom360' || distinctTestAreas[x].TestAreaName == 'Student360' ||  distinctTestAreas[x].TestAreaName == 'Practice360' || distinctTestAreas[x].TestAreaName == 'Portal') {
                this.testAreas.push(distinctTestAreas[x].TestAreaName);
              }
            }

          }

          const distinctSubAreas = distinctTestAreas.filter(
            (thing, i, arr) => arr.findIndex(t => t.TestSubAreaName === thing.TestSubAreaName) === i
          );

          this.testSubAreas = [];
          for (let x = 0; x < distinctSubAreas.length; x++) {
              if (distinctSubAreas[x].TestSubAreaName != null) {
                this.testSubAreas.push(distinctSubAreas[x].TestSubAreaName);
              }

          }

        //   // // // // // console.log(this.testAreas);
        //   // // // // // console.log(this.testSubAreas);

          if (this.testSubAreas.length > 0) {
              this.testSubArea = this.testSubAreas[0];
          }

          if (this.testAreas.length > 0) {
            this.testArea = this.testAreas[0];
          }

        //   if (this.tests.length > 0) {
        //     this.test = this.tests[0];
        //   }


          // this.areas.push()
      }

      getSubAreas(testStep: AutomatedTestStep) {
        console.log(testStep);
        // this.testSubAreas = [];
        // for (let x = 0; x < distinctSubAreas.length; x++) {
        //     if (distinctSubAreas[x].TestSubAreaName != null) {
        //       this.testSubAreas.push(distinctSubAreas[x].TestSubAreaName);
        //     }

        // }

      }

      // testClick(thisTest: AutomatedTest) {
      //   this.test = thisTest;
      //   this.showTests = false;
      //   this.showTestSteps = true;
      //   this.getAutomatedTestSteps(thisTest.Test_ID);
      // }

      getElementAreas() {
       // // // // // // console.log('getElementAreas()');
        // // // // // // console.log(this.elementAreas);
        // // // // // // console.log(this.elementArea);
        // // // // // // console.log(this.testSteps);

        const distinctElementAreas = this.allElements.filter(
            (thing, i, arr) => arr.findIndex(t => t.ElementArea_ID === thing.ElementArea_ID) === i
          );

          this.elementAreas = [];
          for (let x = 0; x < distinctElementAreas.length; x++) {

            if (distinctElementAreas[x].ElementArea_ID != null) {
                this.elementAreas.push(distinctElementAreas[x].ElementAreaName);
            }

          }

        //   this.elementArea = this.elementAreas[0]; // TODO:???
        //   // // // // // console.log(this.elementArea);

          // const distinctSubAreas = distinctElementAreas.filter(
          //   (thing, i, arr) => arr.findIndex(t => t.ElementSubAreaName === thing.ElementSubAreaName) === i
          // );

          // this.elementSubAreas = [];
          // for (let x = 0; x < distinctSubAreas.length; x++) {
          //     if (distinctSubAreas[x].ElementSubAreaName != null) {
          //       this.elementSubAreas.push(distinctSubAreas[x].ElementSubAreaName);
          //     }

          // }


        //   // // // // // console.log(this.elementArea);
        //   // // // // // console.log(this.elementSubArea);

          for (let x = 0; x < this.testSteps.length; x++) {
              if (this.elementArea == null || this.elementArea == undefined || this.elementArea == '') {
                this.elementArea = this.testSteps[x].ElementAreaName;
              }
              if (this.elementSubArea == null || this.elementSubArea == undefined || this.elementSubArea == '') {
                this.elementSubArea = this.testSteps[x].ElementSubAreaName;
              }
              this.elementAreaChanged(this.testSteps[x]);
          }

          // this.getElements();


          // this.areas.push()
      }

     testAreaChanged() {

      this.testSubAreas = [];
      for (let x = 0; x < this.allAreas.length; x++) {
          if (this.allAreas[x].AreaName == this.selectedArea.AreaName) {
              this.testSubAreas.push(this.allAreas[x].SubAreaName);
          }
      }
      // // // // console.log(this.testSubAreas);

    }

    elementAreaChanged(testStep: AutomatedTestStep) {

      // // // console.log(testStep);
        // testStep.ElementAreaName = this.elementArea; // ??
        // testStep.ElementSubAreaName = this.elementSubArea; // ??

        // const distinctSubAreas = this.distinctAreas.filter(
        //   (thing, i, arr) => arr.findIndex(t => t.SubAreaName === thing.SubAreaName) === i
        // );

        // testStep.Element.ElementSubAreas = [];

      //   testStep.ElementSubAreas = []; // ??
      //   for (let x = 0; x < this.allAreas.length; x++) {
      //     if (this.allAreas[x].AreaName == testStep.ElementAreaName) {
      //       testStep.ElementSubAreas.push(this.allAreas[x].SubAreaName);
      //     }

      // }

      const unsortedElementSubAreas: string[] = []; // ??
      for (let x = 0; x < this.allAreas.length; x++) {
        if (this.allAreas[x].AreaName == testStep.ElementAreaName) {
          unsortedElementSubAreas.push(this.allAreas[x].SubAreaName);
        }

    }

      // sort the sub areas
    const sortedElementSubAreas = unsortedElementSubAreas.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);

    testStep.ElementSubAreas = sortedElementSubAreas.filter(
      (thing, i, arr) => arr.findIndex(t => t === thing) === i
    );

    // if (this.inDebugMode) {
    //   console.log('HERE NOW');
    //   console.table(testStep.ElementSubAreas);
    // }

        // // TODO: REMOVE
        // this.elementSubAreas = [];
        // for (let x = 0; x < this.allAreas.length; x++) {
        //     if (this.allAreas[x].AreaName == testStep.ElementAreaName) {
        //       this.elementSubAreas.push(this.allAreas[x].SubAreaName);
        //     }

        // }

        // // // // // console.log(testStep);
        // // // // // console.log(this.elementArea);
        // // // // console.log('sup?');
        // // // // console.log(this.elementSubAreas);

        this.getElements(testStep);

        testStep.Elements = this.elements; // ??

        // testStep.Element = new Element(); // ??

    }

    // elementSubAreaChanged() {
    //     // // // // // console.log('elementSub-AreaChanged()');
    //     this.getElements();
    // }

    // getTestSteps() {
    //     // // // // // // console.log(this.test);
    //     // // // // // // console.log(this.testSteps);
    //     // this.getElements();

    // }

    getElements(step: AutomatedTestStep) {
        this.elements = [];
        // this.elements = this.allElements.filter(e => e.ElementAreaName == this.testArea);
       // this.elements = this.allElements.filter(e => e.ElementAreaName == this.elementArea && (e.ElementSubAreaName == null || e.ElementSubAreaName == undefined || e.ElementSubAreaName == this.elementSubArea));
        this.elements = this.allElements.filter(e => e.ElementAreaName === step.ElementAreaName && e.ElementSubAreaName === step.ElementSubAreaName);

       // Filter the elements so that only distinct elements appear in the drop-down.
        this.elements = this.elements.filter(
            (thing, i, arr) => arr.findIndex(t => t.ElementName === thing.ElementName) === i
          );
        // const E = this.elements.filter(e => e.ElementAreaName == 'Classroom Summary' && e.ElementSubAreaName == 'Side Menu')

        // Sort elements in alphabetical order
        this.elements.sort((a, b) => a.ElementName > b.ElementName ? 1 : -1);

        step.Elements = this.elements;

        // // console.log(E);
        // // console.log(step);

        // // // // // console.log(this.allElements);
        // // // // // console.log(this.allAreas);
        // // // // // console.log(this.elementArea);
        // // // // // console.log(this.elementSubArea);

        // // // // // console.log(this.elements);
        // // // // // console.log('here');

        // // // // // console.log(step.Element);
        // // // // console.log(step);


        // if (step.Element == null || step.Element == undefined) {
        //     step.Element = this.getElementByElement_ID(step.Element_ID);
        // }

        // if (step.Element == null || step.Element == undefined) {
        //     step.Elements = this.elements;
        //     step.Element_ID = this.elements[0].Element_ID;
        //     step.Element = this.elements[0];
        // }

        // // // // // // // console.log(step.Element);
        // // // // // // // console.log(step);


        this.getActions(step.Element, step);


    }

    getElementByElement_ID(element_ID: number): Element {
        const tempElements =  this.allElements.filter(e => e.Element_ID == element_ID);
        return tempElements[0];
    }

  //   getStepByStep_ID(step_ID: number): AutomatedTestStep {
  //     const tempItems =  this.testSteps.filter(e => e.Test_ID == element_ID);
  //     return tempElements[0];
  // }

    getActions(item: Element, step: AutomatedTestStep) {

        // // // console.log(item);
        // // // console.log(step);

       // this.actions = [];

        step.Element = item;

        // // // // // console.log(item);
        // // // // // console.log(step);
        // // // // // // console.log(step.Element);

        if (step.Element == null || step.Element == undefined) {
            step.Element = this.getElementByElement_ID(step.Element_ID);
            // // // // console.log('here');
            // // // // console.log(step.Element);
        }

        if (step.Element_ID == 0) {
          if (step.Element != null && step.Element != undefined) {
            step.Element_ID = step.Element.Element_ID;
          }
        }
        step.Element.Action = '';
        step.Element.Actions = [];

    //     // // // // // // console.log(step.Element.ElementName);

         // // // // // // console.log(item);

    //     const tempElements = this.allElements.filter(e => e.Element_ID.toString() == item.ValueField);
    //     if (tempElements.length > 0) {
    //         // this.element = tempElements[0];

    //         // // // // // // console.log(tempElements);
    //         // step.Element = tempElements[0];

    //         // // // // // // console.log(this.testSteps);

    //         const tempSteps = this.testSteps.filter(e => e.Step_ID == step.Step_ID);

    //         // // // // // // console.log(tempSteps);

    //         const element_ID = Number(item.ValueField);

    //         const myElement = this.getElementByElement_ID(element_ID);
    //         // // // // // // console.log(myElement);

    //         if (tempSteps[0] !== null) {
    //             tempSteps[0].Element  = myElement;

    //            // tempSteps[0].Element = step.Element;
    //            tempSteps[0].Element_ID = myElement.Element_ID; // step.Element.Element_ID;
    //            tempSteps[0].ElementName = myElement.ElementName;
    //            tempSteps[0].ElementArea_ID = myElement.ElementArea_ID;
    //            tempSteps[0].ElementAreaName = myElement.ElementAreaName;
    //            tempSteps[0].ElementSubAreaName = myElement.ElementSubAreaName;
    //        }




    //     //    tempSteps[0].Element = step.Element;
    //     //         tempSteps[0].Element_ID = step.Element.Element_ID;
    //     //         tempSteps[0].ElementName = step.Element.ElementName;
    //     //         tempSteps[0].ElementArea_ID = step.Element.ElementArea_ID;
    //     //         tempSteps[0].ElementAreaName = step.Element.ElementAreaName;
    //     //         tempSteps[0].ElementSubAreaName = step.Element.ElementSubAreaName;
    //         // }
    //         // const tempItems = this.elementListItems.filter(e => e.ValueField == this.element.Element_ID.toString());
    //         // for (let x = 0; x < tempItems.length; x++) {

    //         //    // // // // // // console.log(tempItems[x]);

    //         //     if (tempItems[x].ValueField = item.ValueField) {
    //         //         tempItems[x].IsSelected = true;
    //         //         step.Element.ElementName = tempItems[x].TextField;
    //         //         step.Element.Element_ID = Number(item.ValueField);
    //         //     } else {
    //         //         tempItems[x].IsSelected = false;
    //         //     }
    //         // }
    //         // // // // // // console.log(tempItems);
    //     }

    //     // // // // // // console.log(this.testSteps);
    // //     // for (let x = 0; x < this.testSteps.length; x++) {
    // //     //     // // // // console.log (this.testSteps[x].Element);
    // //     // }
    // //     // // // // // // console.log(tempElements);

    // //     // // // // // // console.log(item);

    // //     // // // // // // console.log(this.element);
    // //    // // // // // // console.log('here now');
    // //     // // // // // // console.log(event);
    // //     // // // // // // console.log(this.test);

    // //     if (this.element == null || this.element == undefined) {
    // //         return;
    // //     }


    if (step.Element.ControlName == 'Test') {
      step.Element.Actions.push('Execute Steps'); // (@TextToEnter)
    }
      else {
        step.Element.Actions.push('Validate Value');
        step.Element.Actions.push('Verify Exists');

        if (step.Element.ControlName == 'Table Cell') {
          step.Element.Actions.push('Click Cell');
          step.Element.Actions.push('Click Cell By Row Number');
          step.Element.Actions.push('Validate Value By Row Number');
        } else if (step.Element.ControlName == 'Table Row') {
          step.Element.Actions.push('Click Row Number');
        }
        else {
          // most controls
          step.Element.Actions.push('Click');
        }

      }


        if (step.Element.ControlName == 'Text Box') {
            step.Element.Actions.push('Enter Text'); // (@TextToEnter)
            step.Element.Actions.push('Clear');
        }

        if (step.Element.ControlName == 'Button') {
           // step.Element.Actions.push('Click');
        }

        if (step.Element.ControlName === 'Sort Button') {
            step.Element.Actions.push('Click Sort Button By Column And Row'); // Column !NAME! and Row !NUMBER!
        }

        if (step.Element.ControlName == 'Combo Box') {
          step.Element.Actions.push('Select Combo Box Item');
          step.Element.Actions.push('Select Combo Box Value');
        }

        if (step.Element.ControlName == 'Drop Down List') {
           // step.Element.Actions.push('Click');
        }

        // if (step.Element.ControlName == 'Table Cell') {
        //   step.Element.Actions.push('Click Cell'); // (@CellValue)
        // }

      if (step.Element.ControlName == 'Table Row') {
        //  step.Element.Actions.push('Click'); // (@TextToEnter)
      }

        for (let x = 0; x < step.Element.Actions.length; x++) {
            if (step.Element.Actions[x] == step.ActionName) {
                step.Element.Action  = step.Element.Actions[x];
            }
        }

        // // // console.log(step);
        // if (this.actions != null && this.actions != undefined) {
        //     this.action = this.actions[0];
        // }

        // step.Element.Actions = this.actions;
        // step.Element.Action = this.action;

        // // // // // // console.log(this.actions);
        // // // // // // console.log(this.action);

        // // // // console.log(step.Element);
        // // // // console.log(step.Element.Actions);
        // // // // console.log(step.Element.Action);

    // //     this.getDataInputs();

    }

    getDataInputs() {

        // // // // // // // console.log('here');
        // // // // // // // console.log(this.action);
        // // // // // // // console.log(this.element);
        // this.dataInput = '';


        // if (this.action == 'Enter Text') {

        //     this.dataInput = this.element.parameterName + ' = ' + this.element.parameterValue;

        // }

    }


    addStep(isSubTest: boolean) {

        this.testSaved = false;
        // // // // // // console.log(this.elementArea);
        // // // // // // console.log(this.elementSubArea);
        // // // // // // console.log('addStep()');

        // console.log('HERE');

        // console.log(this.insertStepNumber);
        // console.log(this.insertStepType);


        if (this.insertStepType == 'Shared Test') {
          this.insertStepType = '';
          // this.addTest();
        }

        let stepOrder = this.testSteps.length + 1;

        if (this.insertStepType == 'Regular Step') { // (this.insertStepNumber > 0) {
          stepOrder = this.insertStepNumber - 1;
          // bump up the remaining step orders
          // for (let x = this.insertStepNumber - 1; x < this.testSteps.length; x++) {
          //   this.testSteps[x].StepOrder++;
          // }
        }

        // for (let x = 0; x < this.testSteps.length; x++) {
        //     this.testSteps[x].StepOrder = x + 1;
        // }

        // console.log(stepOrder);

        const newStep = new AutomatedTestStep();
        newStep.StepOrder = stepOrder;
        newStep.Step_ID = 0;
        newStep.Elements = [];
        newStep.Element = new Element();



        // // // // // // console.log(this.testArea);
        // // // // // // console.log(this.testSubArea);


        if (isSubTest) {

            this.openModalPopup('addSubTest'); // we need to select sub test

            // newStep.Test_ID = 0; // this.test.Test_ID;

            // newStep.ElementAreaName = this.testArea;
            // newStep.ElementSubAreaName = this.testSubArea;

            // newStep.ElementName = this.test.TestName;

            // const elem = new Element();
            // elem.ElementName = this.test.TestName;
            // elem.ElementAreaName = this.testArea;
            // elem.ElementSubAreaName = this.testSubArea;

            // elem.Actions.push('Execute Steps');
            // elem.Action = 'Execute Steps';
            // newStep.Element = elem;
            // newStep.Elements.push(elem);
        }
        else {
          // regular step
          newStep.Test_ID = this.test.Test_ID;

          newStep.ElementAreaName = ''; // this.elementArea;
          newStep.ElementSubAreaName = ''; // this.elementSubArea;

           // this.getElements(newStep);
           // newStep.ElementName = this.elements[0].ElementName;

            // // // // console.log(newStep.Elements);
            // // // // console.log(newStep.Element);
            // // // // console.log(newStep.ActionName);
            // // // // console.log(newStep.Element.Action);
            // // // // console.log(newStep.Element.Actions);

            // // // // console.log(newStep);


            // this.testStep = step;

          //  console.log(stepOrder);

            if (this.insertStepType == 'Regular Step') {
              // this.testSteps.unshift(newStep); // push to beginning of array
              this.testSteps.splice(stepOrder, 0, newStep); // push to beginning of array
            } else {
              this.testSteps.push(newStep); // push to end of array

            }

         }

         this.insertStepType = '';


         // const sortedSteps = this.testSteps.sort((a, b) => a.StepOrder < b.StepOrder ? -1 : a.StepOrder > b.StepOrder ? 1 : 0);

      //    console.log(this.testSteps);
      //    // console.log(sortedSteps);

      // reorder steps
      for (let x = 0; x < this.testSteps.length; x++) {
        this.testSteps[x].StepOrder = x + 1;
      }

     // console.log(this.testSteps);


        //  for (let x = 0; x < sortedSteps.length; x++) {

        //  }


        // // // // // // // console.log(this.area);
        // // // // // // // console.log(this.element);
        // // // // // // // console.log(this.action);
        // // // // // // // console.log(this.actions);

        // let tempAction = this.action;
        // if (this.action == 'EnterText(@TextToEnter)') {
        //     if (this.element.ElementName == 'UserName') {
        //         tempAction = 'EnterText(@UserName)';
        //     }
        //     else if (this.element.ElementName == 'Password') {
        //         tempAction = 'EnterText(@Password)';
        //     }
        //     else if (this.element.ElementName == 'StudentFirstName') {
        //         tempAction = 'EnterText(@StudentFirstName)';
        //     }
        //     else if (this.element.ElementName == 'StudentLastName') {
        //         tempAction = 'EnterText(@StudentLastName)';
        //     }
        //     else if (this.element.ElementName == 'StudentNumber') {
        //         tempAction = 'EnterText(@StudentNumber)';
        //     }
        // }

        // if (this.action == 'ClickCell(@CellValue)') {
        //     this.testText += '\n' + 'set @TableHeaderText= StudentNumber';
        //     tempAction = 'ClickCell(@TableHeaderText, @StudentNumber)';
        // }


        // this.testText += '\n' + this.testArea + '_' + this.element.ElementName + '.' + tempAction;

    }

    deleteStep(step: AutomatedTestStep) {
        // // // // // console.log(step);

        this.confirmDialogRef = this._confirmDialog.open(
          ConfirmModalComponent,
        {
          data: {
              PageTitle: 'Confirm Delete Step',
              Message: 'Are you sure you want to DELETE this STEP?'
            },
          panelClass: 'tyl-mat-dialog',
          disableClose: true,
        });

      this.confirmDialogRef.afterClosed().subscribe(result => {

        // user clicked OK
        if (result == true) {

          // console.log(step);

          this.reportService.deleteAutomatedTestStep(step.Step_ID).subscribe(res => {
          });

            this.testSteps = this.testSteps.filter(obj => obj !== step);

            for (let x = 0; x < this.testSteps.length; x++) {
              this.testSteps[x].StepOrder--;
            }

          // reorder steps
          for (let x = 0; x < this.testSteps.length; x++) {
            this.testSteps[x].StepOrder = x + 1;
          }
        }


        });


      //   this.reportService.deleteAutomatedTestStep(step.Step_ID).subscribe(res => {
      // });

      //   this.testSteps = this.testSteps.filter(obj => obj !== step);
    }

    saveTest(test: AutomatedTest) {
      // // console.log(test);
      this.reportService.saveAutomatedTest(test.Test_ID, test).subscribe(results => {

    });

    }

    setIsSubTestOnly(thisTest: AutomatedTest, checked: boolean) {
      // thisTest.IsSubTestOnly = !thisTest.IsSubTestOnly;
      // // // console.log('checked');
      // // // console.log(checked);
      if (checked) {
        thisTest.IsSubTestOnly = true;
      } else {
        thisTest.IsSubTestOnly = false;
      }

      // // console.log(thisTest);

      this.saveTest(thisTest);
    }

    setApproved(thisTest: AutomatedTest, checked: boolean) {
      // thisTest.Approved = !thisTest.Approved;
      // // // console.log('checked');
      // // // console.log(checked);
      if (checked) {
        thisTest.Approved = true;
      } else {
        thisTest.Approved = false;
      }
      // // console.log(thisTest);
      this.saveTest(thisTest);
    }

    saveTestStepsClick() {


      // for (let x = 0; x < this.testSteps.length; x++) {
      //   this.testSteps[x].Element_ID = this.testSteps[x].Element.Element_ID;
      //   this.testSteps[x].ActionName = this.testSteps[x].Element.Action;
      //   this.testSteps[x].ElementArea_ID = this.testSteps[x].Element.ElementArea_ID;
      //   if (this.testSteps[x].InnerTest_ID == null || this.testSteps[x].InnerTest_ID == undefined) {
      //     this.testSteps[x].InnerTest_ID = 0;
      //   }
      // }

      for (let x = 0; x < this.testSteps.length; x++) {
       // if (this.testSteps[x].Element_ID == 0 || this.testSteps[x].Element_ID == null || this.testSteps[x].Element_ID == undefined) {
          if (this.testSteps[x].Element != null && this.testSteps[x].Element != undefined) {
            this.testSteps[x].Element_ID = this.testSteps[x].Element.Element_ID;
          }
       // }
      }


      // // console.log(this.testSteps);
      // // console.log('here');

      this.reportService.saveAutomatedTestSteps(this.test.Test_ID, this.testSteps).subscribe(res => {

        // // // // // console.log(res);


        this.getAutomatedTests(0);

        this.testSaved = true;

        // this.testSteps = [];
        // this.showTests = true;
        // this.showTestSteps = false;
    });

    }

    actionClicked(testStep: AutomatedTestStep, event: any) {
      // console.log(event);
      // testStep.ActionName = this.actionName;
      // console.log(testStep);
      // // // // console.log(this.testSteps);
    }

    // deleteTest(test_ID: number) {
    //   this.reportService.deleteAutomatedTest(test_ID).subscribe(res => {
    //   });
    //   this.testSteps = [];
    //     this.getAutomatedTests(0);
    //     // this.tests = this.tests.filter(obj => obj.Test_ID !== test_ID);
    // }


    insertStep(step: AutomatedTestStep) {
      // new step will have step order of step clicked

      this.insertStepNumber = step.StepOrder;

      this.openModalPopup('insertStep');

      // the remaining steps after this new step need their order bumped up by one
      // // console.log(step);
      // for (let x = 0; x < this.testSteps.length; x++) {
      //   if (this.testSteps[x].StepOrder == step.StepOrder - 1) {
      //     this.testSteps[x].StepOrder = step.StepOrder;
      //     step.StepOrder = step.StepOrder - 1;
      //   }
      // }

  }


    deleteTest(theTest: AutomatedTest) {
      // // // // // console.log(step);

      const test_ID = theTest.Test_ID;

      this.confirmDialogRef = this._confirmDialog.open(
        ConfirmModalComponent,
      {
        data: {
            PageTitle: 'Confirm Delete Test - ' + theTest.TestName,
            Message: 'Are you sure you want to DELETE this TEST?'
          },
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
      });

    this.confirmDialogRef.afterClosed().subscribe(result => {

      // user clicked OK
      if (result == true) {

        this.reportService.deleteAutomatedTest(test_ID).subscribe(res => {
          this.testSteps = [];
          this.getAutomatedTests(0);
        });
        // this.testSteps = [];
        //   this.getAutomatedTests(0);
      }


      });


    //   this.reportService.deleteAutomatedTestStep(step.Step_ID).subscribe(res => {
    // });

    //   this.testSteps = this.testSteps.filter(obj => obj !== step);
  }

  legendClick() {
    this.reportLegendDialogRef = this.reportLegendDialog.open(ReportLegendComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      data: {
        legendItem_1: 'Shared Test',
        legendItem_2: 'Unapproved'

      },

    });

  }

  getBackgroundColorForTest(element: any) {
    if (element.IsSubTestOnly && element.Approved) {
      return 'AliceBlue';
    }
    if (!element.Approved) {
        return 'LavenderBlush';
      }
    // console.log(element);
  }



    closeClick() {
        this.thisDialogRef.close();
    }

    testChanged() {

    }

    getAutomatedTestParameters(testId: number, paramId: number) { // testId, int paramId)

    this.reportService.getAutomatedTestParameters(testId, paramId).subscribe(res => {
      this.parameters = res;
      // console.log(this.parameters);

    });
  }

  // saveAutomatedTestParameter(testId: number, paramId: number) { // testId, int paramId)

  //   // this.reportService.saveAutomatedTestParameter(testId, paramId).subscribe(res => {

  //   // });

  // }

  showParameterGrid(show: boolean) {

    this.showParameters = show;
    this.showTestSteps = !show;
    this.showTests = false;

    // this.reportService.getAutomatedTestParameters(this.test.Test_ID, 0).subscribe(res => {
    //   this.parameters = res;
    //   // console.log(this.parameters);
    // });

  }

  editParameterClick(param: AutomatedTestParameter) {
    this.parameter = param;
    this.openModalPopup('editParameter');
  }

  addParameter() {

    this.parameter = new AutomatedTestParameter;
    this.parameter.ParameterValue  = '';
    this.openModalPopup('addParameter');
  }

  deleteParameter(param: AutomatedTestParameter) {
    this.confirmDialogRef = this._confirmDialog.open(
      ConfirmModalComponent,
    {
      data: {
          PageTitle: 'Confirm Delete Parameter ' + param.ParameterName,
          Message: 'Are you sure you want to DELETE this PARAMETER?'
        },
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });

  this.confirmDialogRef.afterClosed().subscribe(result => {

    // user clicked OK
    if (result == true) {

      this.reportService.deleteAutomatedTestParameter(param.Test_ID, param.ID).subscribe(success => {

        this.reportService.getAutomatedTestParameters(0, 0).subscribe(res => {
          this.parameters = res;
         // console.log(this.parameters);
          this.showParameterGrid(false);

        });

      });

    }


    });


  //   this.reportService.deleteAutomatedTestStep(step.Step_ID).subscribe(res => {
  // });

  //   this.testSteps = this.testSteps.filter(obj => obj !== step);
}

setTestStatus() {
  for (let x = 0; x < this.tests.length; x++) {

    this.tests[x].SelectedStatus = AutomatedTestStatus.InProgress; // default
    this.tests[x].SelectedStatusDescription = 'In Progress';

    if (this.tests[x].IsObsolete) {
      this.tests[x].SelectedStatus = AutomatedTestStatus.IsObsolete;
      this.tests[x].SelectedStatusDescription = 'Obsolete';
    }
    else if (this.tests[x].InProgress) {
      this.tests[x].SelectedStatus = AutomatedTestStatus.InProgress;
      this.tests[x].SelectedStatusDescription = 'In Progress';
    }
    else if (this.tests[x].Approved) {
      this.tests[x].SelectedStatus = AutomatedTestStatus.Approved;
      this.tests[x].SelectedStatusDescription = 'Approved';
    }
    else if (this.tests[x].ReadyForReview) {
      this.tests[x].SelectedStatus = AutomatedTestStatus.ReadyForReview;
      this.tests[x].SelectedStatusDescription = 'Ready for Review';

    }

    // in case all bit flags are false
    if (this.tests[x].SelectedStatus == AutomatedTestStatus.InProgress) {
      this.tests[x].InProgress = true;
    }
  }
  // console.log(this.tests);
}

    showElementList() {

        this.elementListDialogRef = this._elementListDialog.open(ElementListModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Element List',
              Message: 'A list of all the elements. You may click the Action button to interact with the element.',
            }
          });

    }

    showModulePortalList() {

        this.areaListDialogRef = this._areaListDialog.open(AreaListModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Module / Portal List',
              Message: 'A list of all the Modules and Portals. You may click the Action button to interact with the Portal.',
            }
          });

    }

    showPageTabList() {

        this.areaListDialogRef = this._areaListDialog.open(AreaListModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Page & Tab / View List',
              Message: 'A list of all the pages and their tabs and views. You may click the Action button to interact with the page / tab / view.',
            }
          });

    }

}


